module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "fluid narrow",
    attrs: {
      "dialog": "modal-x-sm"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("New note")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "wrapper fs-normal"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    attrs: {
      "autofocus": "",
      "rows": "8",
      "placeholder": "What's on your mind?"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.types) ? _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn yes wide my-3 w-100",
    attrs: {
      "type": "button",
      "disabled": _vm.getIsUpdatingEventNote
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f15c254"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/NoteAdd.vue
// module id = 1435
// module chunks = 0